import type {
  CallConfig,
  CallDisposition,
  CallPurpose,
  CallScorecardCriterion,
  DialerPreferences,
  RecordingRule,
  VoicemailDrop,
} from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPost, apiPut } from "./client";

export function getCallConfig(): Promise<{ config: CallConfig }> {
  return apiGet("/api/call-config");
}

export function updateCallConfig(body: {
  purposes?: CallPurpose[];
  dispositions?: CallDisposition[];
  recordingRules?: RecordingRule[];
  preferences?: Partial<DialerPreferences>;
  voicemailDrops?: VoicemailDrop[];
  scorecardCriteria?: CallScorecardCriterion[];
}): Promise<{ config: CallConfig }> {
  return apiPut("/api/call-config", body);
}

export function updateDialerPreferences(
  preferences: Partial<DialerPreferences>,
): Promise<{ config: CallConfig }> {
  return apiPut("/api/call-config/preferences", preferences);
}

export function savePurpose(
  purpose: Partial<CallPurpose> & { name: string },
): Promise<{ config: CallConfig }> {
  return apiPost("/api/call-config/purposes", purpose);
}

export function removePurpose(
  purposeId: string,
): Promise<{ config: CallConfig }> {
  return apiDelete(`/api/call-config/purposes/${purposeId}`);
}

export function saveDisposition(
  disposition: Partial<CallDisposition> & {
    name: string;
    result: CallDisposition["result"];
  },
): Promise<{ config: CallConfig }> {
  return apiPost("/api/call-config/dispositions", disposition);
}

export function removeDisposition(
  dispositionId: string,
): Promise<{ config: CallConfig }> {
  return apiDelete(`/api/call-config/dispositions/${dispositionId}`);
}

export function saveRecordingRule(
  rule: Partial<RecordingRule> & {
    country: string;
    inboundParties: RecordingRule["inboundParties"];
    outboundParties: RecordingRule["outboundParties"];
  },
): Promise<{ config: CallConfig }> {
  return apiPost("/api/call-config/recording-rules", rule);
}

export function removeRecordingRule(
  ruleId: string,
): Promise<{ config: CallConfig }> {
  return apiDelete(`/api/call-config/recording-rules/${ruleId}`);
}

export function saveVoicemailDrop(
  drop: Partial<VoicemailDrop> & { label: string; audioUrl: string },
): Promise<{ config: CallConfig }> {
  return apiPost("/api/call-config/voicemail-drops", drop);
}

export function removeVoicemailDrop(
  dropId: string,
): Promise<{ config: CallConfig }> {
  return apiDelete(`/api/call-config/voicemail-drops/${dropId}`);
}

export function saveScorecardCriterion(
  criterion: Partial<CallScorecardCriterion> & { label: string },
): Promise<{ config: CallConfig }> {
  return apiPost("/api/call-config/scorecards", criterion);
}

export function removeScorecardCriterion(
  criterionId: string,
): Promise<{ config: CallConfig }> {
  return apiDelete(`/api/call-config/scorecards/${criterionId}`);
}
